import appConfig from 'app-config';
import defaultFieldsJson from './MLHVQDefaultFields.json';

const {
    HVQConsumerSteps
} = appConfig;

export default {
    isFieldDefaultedByHVQ: (compRaterVendor, accesorCodeOrID, currentStepName) => {
        const compRaterVendorJson = defaultFieldsJson[compRaterVendor];
        return new Set(HVQConsumerSteps).has(currentStepName)
            && !!compRaterVendorJson &&!!compRaterVendorJson[currentStepName][accesorCodeOrID];
    }
};